module.exports = __webpack_public_path__ + "img/477.2182ec6b.png";